import { Link as ReactRouterLink } from 'react-router';
import { styled } from '@mui/material/styles';

export const Link = styled(ReactRouterLink)(() => ({
  textDecoration: 'none',
  color: 'inherit',
}));
export const UnderlineLink = styled(ReactRouterLink)(({ theme }) => ({
  textDecoration: 'underline',
  color: 'inherit',
  ':hover': {
    color: theme.palette.accent,
  },
}));